import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "input", "submit", "source"];

  reveal() {
    this.modalTarget.dispatchEvent(
      new CustomEvent("confirm-with-input:open", { bubbles: false }),
    );
  }

  sourceChanged() {
    this.inputTarget.value = "";
    this.submitTarget.disabled = true;
  }

  validate() {
    this.submitTarget.disabled =
      this.inputTarget.value !== this.#expectedValue;
  }

  get #expectedValue() {
    switch (this.sourceTarget.tagName) {
      case "SELECT":
        return this.sourceTarget.selectedOptions[0].text;
      default:
        return this.sourceTarget.value;
    }
  }
}
